import {
  GET_ALL_PROVIDER_EXPORT_LIST,
  GET_ALL_PROVIDER_EXPORT_LIST_FAILURE,
  GET_ALL_PROVIDER_EXPORT_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAllProviderExportListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PROVIDER_EXPORT_LIST:
      return { ...state, loading: true };
    case GET_ALL_PROVIDER_EXPORT_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_ALL_PROVIDER_EXPORT_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAllProviderExportListReducer;
